export default __webpack_public_path__ + "static/media/img (1).8057ec55.jpg";